import { jsx } from 'react/jsx-runtime';
import { isValidElement, cloneElement } from 'react';

const clamp = (min, max) => Math.min(Math.max(min + (window.innerWidth - 375) / (1920 - 375) * (max - min), min), max);
const NewLineToBr = props => {
  var _a;
  const lines = (_a = props.text) === null || _a === void 0 ? void 0 : _a.split('\n').map(function (line, n) {
    return n == 0 ? [jsx("span", {
      dangerouslySetInnerHTML: {
        __html: line
      }
    }, `line-${n}`)] : [jsx("br", {}, `line-${n * 2}`), jsx("span", {
      dangerouslySetInnerHTML: {
        __html: line
      }
    }, `line-${n * 2 + 1}`)];
  });
  return lines;
};
const regExpMapper = function (text, dict, rest) {
  if (rest === void 0) {
    rest = text => text;
  }
  if (!text) {
    return;
  }
  const find = new RegExp(`(${Object.keys(dict).join(')|(')})|(.+)`, 'g');
  const replacers = Object.values(dict);
  const nodes = [];
  text.replace(find, function () {
    for (var _len = arguments.length, matches = new Array(_len), _key = 0; _key < _len; _key++) {
      matches[_key] = arguments[_key];
    }
    const index = matches.findIndex((v, i) => i > 0 && v !== undefined);
    const value = matches[index];
    const replace = replacers[index - 1];
    let mappedValue = '';
    if (typeof replace === 'function') {
      mappedValue = replacers[index - 1](value);
    } else {
      mappedValue = rest(value);
    }
    const element = /*#__PURE__*/isValidElement(mappedValue) ? /*#__PURE__*/cloneElement(mappedValue, Object.assign({
      key: nodes.length
    }, mappedValue.props)) : mappedValue;
    nodes.push(element);
    return '';
  });
  return nodes;
};
const messageMapper = text => {
  return regExpMapper(text, {
    '\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff]': text => jsx("span", {
      "aria-hidden": true,
      children: text
    }),
    '\n': () => jsx("br", {})
  }, text => jsx("span", {
    children: text
  }));
};

export { NewLineToBr, clamp, messageMapper, regExpMapper };
//# sourceMappingURL=utils.js.map
